/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
	{
		url: "/dashboard/home",
		name: "Control Panel",
		slug: "control-panel",
		icon: "ColumnsIcon",
		i18n: "ControlPanel",
		permission_id: [25, 26, 27, 28],
		permission_name: "ROUTER",
	},
	{
		header: "Apps",
		icon: "PackageIcon",
		i18n: "Modules",
		items: [
			{
				url: null,
				name: "Optimizations",
				slug: "optimizations",
				icon: "AirplayIcon",
				i18n: "Optimization.Optimizations",
				permission_id: [25, 26, 27, 28],
				permission_name: "ROUTER",
				submenu: [
					{
						url: "/dashboard/optimization",
						name: "CREATE_OPTIMIZATION",
						slug: "app-optimization",
						i18n: "Crud.Create",
					},
					{
						url: "/dashboard/optimization/list",
						name: "List",
						slug: "optimizationList",
						i18n: "Crud.List",
					},
				],
			},
			//CLUSTERING
			{
				url: "/apps/clustering",
				name: "Clustering",
				slug: "clustering",
				icon: "PieChartIcon",
				i18n: "Clustering.Title",
				permission_id: [1, 2, 3, 4],
				permission_name: "CLUSTERING",
			},
			//  Skills
			{
				url: "/dashboard/skills/list",
				name: "Skills",
				slug: "skills",
				icon: "AwardIcon",
				i18n: "Skills.Skills",
				permission_id: [33, 34, 35, 36],
				permission_name: "SKILLS",
			},
			//  Capacity
			{
				url: "/dashboard/capacity/capacity-list",
				name: "Capabilities",
				slug: "capabilities",
				icon: "BoxIcon",
				i18n: "Capacity.Capabilities",
				permission_id: [1, 2, 3, 4],
				permission_name: "CAPABILITIES",
			},
			//VENTANAS HORARIAS
			{
				url: "/apps/time-window/time-window-list",
				name: "TimeWindowList",
				icon: "ClockIcon",
				slug: "app-time-window-list",
				i18n: "TimeWindow.TimeWindows",
				permission_id: [1, 2, 3, 4],
				permission_name: "TIMEWINDOW",
			},
			//FRECUENCIAS
			{
				url: "/apps/frequency/frequency-list",
				name: "FrequencyList",
				icon: "RadioIcon",
				slug: "app-frequency-list",
				i18n: "Frequency.Frequencies",
				permission_id: [1, 2, 3, 4],
				permission_name: "TIMEWINDOW",
			},
			//VEHICULOS
			{
				url: "/apps/vehicle/vehicle-list",
				name: "VehicleList",
				icon: "TruckIcon",
				slug: "app-vehicle-list",
				i18n: "Vehicles.Vehicles",
				permission_id: [21, 22, 23, 24],
				permission_name: "VEHICLE",
			},
			//PUNTO DE VISITA
			{
				url: "/apps/visit-point/visit-point-list",
				name: "VisitPointList",
				icon: "MapPinIcon",
				slug: "app-visit-point-list",
				i18n: "Routing.Title.VisitPoints",
				permission_id: [1, 2, 3, 4],
				permission_name: "VISITPOINT",
			},
			//Optimization Group
			{
				url: "/apps/optimization-group/optimization-group",
				name: "OptimizationGroup",
				slug: "app-optimization-group-list",
				icon: "LinkIcon",
				i18n: "Group.Groups",
				permission_id: [1, 2, 3, 4],
				permission_name: "OPTIMIZATIONGROUP",
			},
			//  Deposits
			{
				url: "/dashboard/deposits/list",
				name: "Deposits",
				slug: "deposits",
				icon: "HomeIcon",
				i18n: "Deposits.Depot",
				permission_id: [9, 10, 11, 12],
				permission_name: "DEPOSITS",
			},
			//  Breaks
			{
				url: "/dashboard/breaks/list",
				name: "Breaks",
				slug: "breaks",
				icon: "CoffeeIcon",
				i18n: "Breaks",
				permission_id: [1, 2, 3, 4],
				permission_name: "BREAKS",
			},
			//  Teams
			{
				url: "/dashboard/teams/list",
				name: "Teams",
				slug: "teams",
				icon: "UsersIcon",
				i18n: "Teams.Teams",
				permission_id: [41, 42, 43, 44],
				permission_name: "TEAMS",
			},
			// Indicators
			{
				url: "/dashboard/indicator",
				name: "INDICATORS",
				slug: "indicator",
				icon: "TrelloIcon",
				tagColor: "success",
				i18n: "Indicators.Indicators",
				permission_id: [53, 54, 55, 56],
				permission_name: "INDICATORS",
			},
			//UploadFile
			{
				url: null,
				name: "UPLOAD_FILES",
				slug: "resource-upload-files",
				icon: "UploadIcon",
				tagColor: "success",
				i18n: "UploadFiles.UploadFiles",
				submenu: [
					{
						url: "/apps/UploadFiles",
						name: "UPLOAD_FILES",
						slug: "app-upload-files",
						i18n: "Upload",
					},
					{
						url: "/apps/UploadFileList",
						name: "List",
						slug: "app-upload-file-list",
						i18n: "Crud.List",
					},
				],
			},
		],
	},
	{
		header: "CONFIG",
		icon: "PackageIcon",
		i18n: "Configuration",
		items: [
			//COMPANY
			{
				url: "/dashboard/company",
				name: "Company",
				slug: "extra-component-maps-google-map",
				icon: "BriefcaseIcon",
				i18n: "Company",
				permission_id: [49, 50, 51, 52],
				permission_name: "COMPANY",
			},
			//COMPANY_CONFIG
			{
				url: "/dashboard/setting",
				name: "TypeConfig",
				slug: "typeconfig",
				icon: "ToolIcon",
				i18n: "CompanyConfigCrud",
				permission_id: [45, 46, 47, 48],
				permission_name: "TYPE CONFIG",
			},
			//TYPE CONFIG
			{
				url: "/dashboard/typeconfig/list",
				name: "TypeConfig",
				slug: "typeconfig",
				icon: "SettingsIcon",
				i18n: "TypeConfig.Title",
				permission_id: [45, 46, 47, 48],
				permission_name: "TYPE CONFIG",
			},
			// RECURSOS
			{
				url: "/apps/resource/resources-list",
				name: "List",
				icon: "UserIcon",
				slug: "app-resource-list",
				i18n: "User",
				permission_id: [21, 22, 23, 24],
				permission_name: "RESOURCES",
			},
			//SESSION API
			{
				url: "/dashboard/session-api",
				slug: "sessionapi",
				name: "SessionApi",
				icon: "KeyIcon",
				i18n: "SessionApi.SessionApi",
				permission_id: [45, 46, 47, 48],
				permission_name: "TYPE CONFIG",
			},
			//OPTIMIZER MANAGER
			{
				url: "/apps/optimizer-manager/optimizer-manager-list",
				name: "OptimizerManager",
				slug: "eoptimizermanager",
				icon: "TrendingUpIcon",
				i18n: "OptimizerManager.Optimizers",
				permission_id: [49, 50, 51, 52],
				permission_name: "OPTIMIZERMANAGER",
			},
			//ROLES
			{
				url: "/dashboard/role",
				name: "Role",
				slug: "extra-component-maps-google-map",
				icon: "UsersIcon",
				i18n: "MODULE_ROLE.Roles",
				permission_id: [29, 30, 31, 32],
				permission_name: "ROLE",
			},
			//PERMISSIONS
			{
				url: "/dashboard/permission",
				name: "Role",
				slug: "extra-component-maps-google-map",
				icon: "ShieldOffIcon",
				i18n: "MODULE_PERMISSION.Permissions",
				permission_id: [17, 18, 19, 20],
				permission_name: "PERMISSION",
			},
			//STATUS
			{
				url: "/dashboard/status/list",
				name: "Status",
				slug: "status",
				icon: "BookmarkIcon",
				i18n: "Status.Title",
				permission_id: [37, 38, 39, 40],
				permission_name: "STATUS",
			},
		],
	},
	// Se agrega un menu en blanco para generar espacio en el ultimo elemento y se pueda ver
	{
		header: "\n",
		icon: "",
		i18n: "",
		items: [],
	},
];
